import { isEqual } from 'lodash';
import React, { useState } from 'react';
import { Option } from '@mm/components';
import { AudiencesSelector } from '../../../../../campaigns/components/AudiencesSelector/AudiencesSelector';
import styles from '../DemographicAnalytics.module.css';
import { useSelector } from 'react-redux';
import { selectAudiences } from '@mm/state/selectors/messengerAdSelectors';

type Props = {
  selectedAudiencesIds?: number[];
  setSelectedAudiencesIds: (ids: number[]) => void;
  disabled?: boolean;
};

export const DemographicAudienceSelect = ({
  selectedAudiencesIds,
  setSelectedAudiencesIds,
  disabled,
}: Props) => {
  const [selectedAudiences, setSelectedAudiences] = useState<Option[]>([]);
  const audiences = useSelector(selectAudiences);

  const audiencesIdsToOptions = selectedAudiencesIds?.map(
    id =>
      ({
        id,
        label: audiences.find(a => a.id === id)?.name,
      } as Option),
  );

  const onAudienceSelectorChange = (value: Option<string | number>[]) => {
    setSelectedAudiences(value);
    const audiencesEqual =
      audiencesIdsToOptions || value.length
        ? isEqual(value, audiencesIdsToOptions)
        : true;

    if (!audiencesEqual) {
      const ids = value.map(v => Number(v.id));
      setSelectedAudiencesIds(ids);
    }
  };

  return (
    <AudiencesSelector
      className={styles.audienceSelector}
      selected={selectedAudiences}
      onChange={onAudienceSelectorChange}
      label={!selectedAudiences.length ? 'All Contacts' : ''}
      placeholder=""
      disabled={disabled}
      singleSelect
      hideCount
      onlyEsAudiences
    />
  );
};
